var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.75H7C3.35 21.75 1.25 19.65 1.25 16V9C1.25 5.35 3.35 3.25 7 3.25H17C20.65 3.25 22.75 5.35 22.75 9V16C22.75 19.65 20.65 21.75 17 21.75ZM7 4.75C4.14 4.75 2.75 6.14 2.75 9V16C2.75 18.86 4.14 20.25 7 20.25H17C19.86 20.25 21.25 18.86 21.25 16V9C21.25 6.14 19.86 4.75 17 4.75H7Z",
    fill: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.37C11.1598 13.37 10.3098 13.11 9.65978 12.58L6.52978 10.08C6.20978 9.81997 6.14978 9.34997 6.40978 9.02997C6.66978 8.70997 7.13978 8.64997 7.45978 8.90997L10.5898 11.41C11.3498 12.02 12.6398 12.02 13.3998 11.41L16.5298 8.90997C16.8498 8.64997 17.3298 8.69997 17.5798 9.02997C17.8398 9.34997 17.7898 9.82997 17.4598 10.08L14.3298 12.58C13.6898 13.11 12.8398 13.37 11.9998 13.37Z",
    fill: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f6df34f51f35a6cb8a621bf9cbec5790.svg";
export { ForwardRef as ReactComponent };